import CH21Page from "components/pages/CH21Page";

export default function CaptureMabiCH21(props) {
    return <CH21Page removeAB22IContainer={true}/>
}